import {
  AppInfo,
  AppInfoListReq,
  Pagination,
  User,
  ImplListRespItem,
  ParseAppStatus,
  WidgetImplInfoProps,
  ApprovalDetailResp,
  AppVersionInfoItem,
  WidgetInfo,
  WidgetData,
  WidgetDetile,
  multiLangList,
  CountryList,
  EnumList,
  multiLangParse,
} from './dto';
import { httpService } from './httpService';

const apiService = {
  getCurrentUser() {
    return httpService.get<void, User>('/api/login/info');
  },

  getAppList(params: AppInfoListReq) {
    // const mockData = [
    //   { iconUrl: '', appName: '万能遥控器', packageName: 'com.mi.xxx' },
    //   { iconUrl: '', appName: '美团', packageName: 'com.meituan.xxx' },
    //   { iconUrl: '', appName: '支付宝', packageName: 'com.alipay.xxx' },
    // ];
    // return Promise.resolve(mockData);

    return httpService.get<void, Pagination<AppInfo>>(
      `/api/app/list?uploadType=${params.updateType}&keyword=${params.keyword}&page=${params.page}&size=${params.pageSize}`,
    );
  },
  //获取应用下小部件列表
  getWidget(appPackage: string, appVerCode: string) {
    return httpService.get<void, WidgetData>(
      `/api/widget/${appPackage}/${appVerCode}`,
    );
  },
  /**
   * 上传图片
   * fds地址：https://cloud.mioffice.cn/#/product/file-store/objects/assistant-models
   * @param file 图片
   * @param directory 文件目录
   */
  imgUpload(file: File) {
    ///ability/impl/upload
    const fd = new FormData();
    fd.append('file', file);
    // fd.append('directory', directory);

    return httpService.post<void, string>(
      '/api/upload/',
      // 'http://api.fe.assistant.srv/cdn/upload/single-file',
      fd,
      {
        headers: { 'content-type': 'multipart/form-data' },
      },
    );
  },

  //gp上传
  gpAppUpload(appName: string, appPkgName: string, file: File) {
    const formdata = new FormData();
    formdata.append('appName', appName);
    formdata.append('appPkgName', appPkgName);
    formdata.append('apkFile', file);
    return httpService.post<void, string>('/api/app/gp/upload', formdata, {
      headers: { 'content-type': 'multipart/form-data' },
    });
  },

  //国家接口获取
  getCountryList(params: { appPkgName: string; verCode: string }) {
    return httpService.get<void, CountryList>(
      `/api/widget/region/${params.appPkgName}/${params.verCode}`,
    );
  },

  //公共枚举类型
  getEnumList() {
    return httpService.get<void, EnumList>('/api/enums/');
  },

  // 小部件详情list
  getImplList(params: {
    abilityCode: string;
    appId: number;
    abilityVersion: number;
    condition: string;
  }) {
    return httpService.post<void, ImplListRespItem[]>(
      '/ability/impl/getImplList',
      params,
    );
  },
  // 小部件排序
  imlpSort(params: { appPkgName: string; implSortBOList: number[] }) {
    return httpService.put<void, boolean>(
      `/api/widget/order/${params.appPkgName}`,
      params.implSortBOList,
    );
  },
  // 小部件所有版本
  getAppVersionList(params: { appId: number; abilityCode: string }) {
    return httpService.post<void, AppVersionInfoItem[]>(
      '/app/getAppVersionInfoList',
      params,
    );
  },

  //多语言包解析
  uploadLanguageParse(file: File) {
    const formdata = new FormData();
    formdata.append('file', file);
    return httpService.post<void, multiLangParse> ('/api/widget/parse/lan', formdata, {
      headers: { 'content-type': 'multipart/form-data' }
    })
  },
  // 获取app的小部件状态
  getAppStatus(params: {
    abilityCode: string;
    abilityVersion: number;
    appId: number;
    appVersionName: string;
    appVersionCode: number;
  }) {
    return httpService.post<
      void,
      {
        state: ParseAppStatus;
      }
    >('/app/appStatus', params);
  },
  ///ability/impl/updateAbilityImpl  保存小部件
  updateAbilityImpl(params: {
    id: number;
    regionList: string[];
    multiLangList: multiLangList[];
  }) {
    return httpService.post<void, boolean>(`/api/widget/${params.id}`, params);
  },
  // /ability/impl/onlineAppVersions 查询小部件上线的app版本
  onlineAppVersions(params: {
    abilityCode: string;
    abilityImplCode: string;
    appId: number;
  }) {
    return httpService.post<void, string[]>(
      '/ability/impl/onlineAppVersionNames',
      params,
    );
  },
  // /ability/impl/updateStatus 修改小部件状态
  updateStatus(params: {
    abilityCode: string;
    abilityImplCode: string;
    appVersionNameList: string[];
    status: number;
  }) {
    return httpService.post<void, boolean>(
      '/ability/impl/updateStatus',
      params,
    );
  },

  //下线小部件
  offLineWidget(params: { wdId: string; versionList: string[] }) {
    return httpService.delete<void, boolean>(`/api/widget/${params.wdId}`, {
      data: params.versionList,
    });
  },
  // //approval/commit 提交审核接口
  commit(params: { appPkgName: string; verCode: string }) {
    return httpService.put<void, boolean>(
      `/api/widget/${params.appPkgName}/${params.verCode}`,
    );
  },
  // approval/detail 审核失败理由接口
  getApprovalDetail(params: {
    abilityCode: string;
    abilityVersion: number;
    approvals: { code: string }[];
  }) {
    return httpService.post<void, ApprovalDetailResp>(
      '/approval/detail',
      params,
    );
  },
  // 获取应用编辑页配置信息
  getAppEditConfig(params: { id: number }) {
    return httpService.get<void, WidgetDetile>(
      `/api/widget/detail/${params.id}`,
    );
  },
};

export { apiService };
